<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'generic.proposals' | translate }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="closeDialogue()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div>
  <div class="container-fluid">
    <div class="col-12">
      <div class="box flex-column border-0 container justify-content-between" style="background-color: #F1F2F2">
        @if (suggestedProposals.length > 0) {
          <table mat-table [dataSource]="suggestedProposals"
            class="mat-elevation-z8 my-5">
            <!-- Name Column -->
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef> {{
                "generic.title"
                | translate
              }} </th>
              <td mat-cell *matCellDef="let element">
                <a [href]="element.link" target="_blank">{{element.title}}</a></td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> {{
                  "generic.type"
                  | translate
                }} </th>
                <td mat-cell *matCellDef="let element">
                  @if (element?.original_proposal_id) {
                    <span>{{ 'generic.revision' | translate }}</span>
                  }
                  @if (!element?.original_proposal_id) {
                    <span>{{ 'generic.new-proposal' | translate }}</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef> {{
                  "generic.upload_date"
                  | translate
                }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.created_at | formatdate | date : 'short'}} </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="ml-auto text-right"> {{
                  "generic.actions"
                  | translate
                }} </th>
                <td mat-cell *matCellDef="let element" class="ml-auto text-right">
                  <button mat-button
                    (click)="viewProposal(element)"
                    class="p-0"
                    color="primary">
                    <small>{{'generic.view' | translate}}</small>
                    <mat-icon>forward</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          }
        </div>
      </div>
    </div>
  </div>
